import styled from 'styled-components';
export const StyledSVG = styled.svg `
  // TODO: is this the final color? because with inherit, theming will only work if a parent defines a color
  color: inherit;
`;
//# sourceMappingURL=index.styles.js.map